import React from "react";
import styled from "styled-components";
import MuzeLogo from "../../../images/logo.svg";

const StyledLogo = styled.img`
    width: 210px;
    float: left;
`;

const AuthLogo = () => <StyledLogo src={MuzeLogo} alt="Muze" />;

export default AuthLogo;
